<template>
  <div id="table-exhibitor" class="result-table">
    <el-table
      :data="results"
      stripe
      border
      @expand="fetchExhibitedWork"
      @sort-change="setOrderColumn">
      <el-table-column type="expand">
        <template slot-scope="props">
          <p>
            <span v-if="props.row.gender">
              {{$t('pages.results.gender')}} : {{props.row.gender}}
            <br></span>
            <span v-if="props.row.biography">
              {{$t('pages.results.biography')}} : {{props.row.biography}}
            <br></span>
            <span v-if="props.row.nationality">
              {{$t('pages.results.nationality')}} : {{props.row.nationality}}
            <br></span>
            <span v-if="props.row.birth_address">
              {{$t('pages.results.birthSpace')}} :
              {{props.row.birth_address}}
              {{props.row.road_num_b}}
              {{props.row.road_b}}
              {{props.row.floor_b}}
              {{props.row.locality_b}}
              {{props.row.complement_b}}
              {{props.row.city_b}}
              {{props.row.state_b}}
              {{props.row.country_b}}
            <br></span>
            <span v-if="props.row.year_b">
              {{$t('pages.results.birthDate')}} :
              <span v-if="props.row.day_b">{{ props.row.day_b }} / </span>
              <span v-if="props.row.month_b">{{ props.row.month_b }} / </span>
              {{ props.row.year_b }}
            <br></span>
            <span v-if="props.row.death_address">
              {{$t('pages.results.deathSpace')}} :
              {{props.row.death_address}}
              {{props.row.road_num_d}}
              {{props.row.road_d}}
              {{props.row.floor_d}}
              {{props.row.locality_d}}
              {{props.row.complement_d}}
              {{props.row.city_d}}
              {{props.row.state_d}}
              {{props.row.country_d}}
            <br></span>
            <span v-if="props.row.year_d">
              {{$t('pages.results.deathDate')}} :
              <span v-if="props.row.day_d">{{ props.row.day_d }} / </span>
              <span v-if="props.row.month_d">{{ props.row.month_d }} / </span>
              {{ props.row.year_d }}
            <br></span>
            <span v-if="props.row.notes">
              {{$t('pages.results.notes')}} : {{props.row.notes}}
            </span>
          </p>

          <h3 v-if="props.row.sections.count === 0">{{$t('pages.results.exhibitedWork')}} : {{$t('pages.results.unknown')}}</h3>
          <h3 v-if="props.row.sections.count === 1">{{$t('pages.results.exhibitedWork')}} : {{props.row.sections.count}}</h3>
          <h3 v-if="props.row.sections.count > 1">{{$t('pages.results.exhibitedWorks')}} : {{props.row.sections.count}}</h3>

          <div
            v-if="props.row.sections"
            v-loading="props.row.sections.loading"
            v-for="section in props.row.sections.results"
            :key="section.id"
          >
            <p>
              <strong>
                <span v-if="section.section_title">{{$t('pages.results.section')}} {{section.section_title || $t('pages.results.noSection')}}</span><span v-if="section.space" class="space"><span v-if="section.section_title">, </span>{{section.space}}</span><span v-if="section.section_address" class="section_address"><span v-if="section.section_title">, </span><span v-else-if="section.space">, </span>{{section.section_address}}</span>
              </strong>
              <span
                v-if="section.id_exhibition_section"
                @click="openSectionDialog(section.id_exhibition_section)"
                class="section-link"
              >
                {{$t('pages.results.section_link')}}
              </span>
              <br>
            </p>

            <ExhibitedWorks v-if="section.exhibitedWorks" :exhibitedWorks="section.exhibitedWorks"></ExhibitedWorks>
            <cite>
              {{$t('pages.results.credits')}}
              {{$t('pages.results.filledBy')}}
              <span v-if="section.contributor">{{ section.contributor }}.</span>
              <span v-else>{{$t('pages.results.contributorUnkown')}}</span>
            </cite>
          </div>

        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        sortable
        width="120"
        :label="$t('pages.results.name')" />
      <el-table-column
        prop="first_name"
        sortable
        width="120"
        :label="$t('pages.results.firstname')" />
      <el-table-column
        :label="$t('pages.results.exhibition')"
        header-align="center"
        >
        <el-table-column
          prop="begin_date"
          sortable
          width="120"
          :formatter="formatDate"
          :label="$t('pages.results.year')"/>
        <el-table-column
          prop="exhibition_city"
          sortable
          width="150"
          label="Ville"/>
        <el-table-column
          prop="exhibition_title"
          sortable
          label="Titre"/>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  Table, TableColumn, Button
} from 'element-ui'
import { formatDate } from '@/services/formatter'
import ExhibitedWorks from '../../ExhibitedWork/ExhibitedWorks.vue'

import { OPEN_SECTION_ID_DIALOG } from '@/store/dialog/actions'

import { GET_EXHIBITED_WORK_FILTERED_BY_COLUMN } from '@/store/search/constants'

export default {
  name: 'table-exhibitor',
  props: ['results', 'setOrderColumn'],
  methods: {
    formatDate,
    fetchExhibitedWork (row, expanded) {
      if (expanded === true) {
        // dispatch action to load exhibited work for row.id exhibitor
        this.$set(row, 'sections', {})
        this.$store.dispatch('search/' + GET_EXHIBITED_WORK_FILTERED_BY_COLUMN, {
          value: row.id,
          column: 'id_exhibitor',
          objectToIncrement: row.sections
        })
      }
    },
    openSectionDialog (id) {
      this.$store.dispatch('dialog/' + OPEN_SECTION_ID_DIALOG, { id })
    }
  },
  components: {
    elTable: Table,
    elTableColumn: TableColumn,
    elButton: Button,
    ExhibitedWorks
  }
}
</script>

<style>
.section-link {
  color: #23a6b9;
}
.section-link:hover,
.section-link:active {
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Result/Tables/TableExhibitor.vue